(function($) {
  $(function() {
    $('button.windows-server').on('click', function() {
      $('div.windows-server').removeClass('hide');
      $('div.sql-server').addClass('hide');
      $('button.sql-server').removeClass('active');
      $('button.windows-server').addClass('active');
    });
    $('button.sql-server').on('click', function() {
      $('div.sql-server').removeClass('hide');
      $('div.windows-server').addClass('hide');
      $('button.windows-server').removeClass('active');
      $('button.sql-server').addClass('active');
    });
  });
})(jQuery);